import { makeAutoObservable, toJS } from 'mobx';

class DataStore {

  sortBy = 'Sort By';
  genderId = '2';
  bookings =[];
  categoryId = '';
  subCategoryId = '';
  productData = null;
  productId = '';
  productName = '';
  featureProductsData = [];
  colorsByProduct = [];
  allColors = '';
  productCategoryId = '';
  productsData = [];
  ordersData = [];
  productsCount = '';
  allchecked = [];
  productQuantity = 1;
  isAddToCart = false;
  isLoader = false;
  isCartIcon = false;
  open = false;
  cartCount = 0;
  allCart = [];
  allCheckoutData = [];
  productSelectedSize = '';
  productSizeQuantity = '';
  isQtySelectionInCart = false;
  myCredits = false;
  deliveryAddress = undefined;
  logout = false;
  myOrders = false;
  myProfile = false;
  myWishlist = false;
  referFriend = false;
  isWishlistByProductId = false;
  wishlistData = [];
  addresses = [];
  isNewAddress = false;
  addressId = 0;
  updateAddress = false;
  isUserLogin = false;
  referCode = '';
  wallet = '';
  productSelectedImg = ''
  isCheckout = false;
  customerLogin = { "custId": "0", "message": "OTP verification fail" };
  totalRefNoAndBalance = '';
  isAddressModalShow = false;
  buyNowLoader = false;
  createOrder = '';
  orderIdForOrderDetails = 0;
  myOrderData = '';
  searchData = [];
  categoiesData = [];
  buyNow = false;
  userData = {};
  orderDetailsData = [];
  orderIdForOrderDetails = [];
  payload = {};


  serviceControlData = {
    UpdateOrderStatus: ""
  }
  constructor() {
    makeAutoObservable(this);
  }

  setPayload(payload) {
    this.payload = payload;
  }

  setUserData(userData) {
    this.userData = userData;
  }
bookings
  setBuyNow(buyNow) {
    this.buyNow = buyNow;
  }

  setOrderIdForOrderDetails(orderIdForOrderDetails) {
    this.orderIdForOrderDetails = orderIdForOrderDetails;
  }
  setGenderId(genderId) {
    this.genderId = genderId;
  }
  setSortBy(sortBy) {
    this.sortBy = sortBy;
  }

  setCategoiesData(categoiesData) {
    this.categoiesData = categoiesData;
  }

  setCategoryId(categoryId) {
    this.categoryId = categoryId;
  }
  setSearchData(searchData) {
    this.searchData = searchData;
  }


  setSubCategoryId(subCategoryId) {
    this.subCategoryId = subCategoryId;
  }

  setProductData(productData) {
    this.productData = productData;
  }

  setProductId(productId) {
    this.productId = productId;
  }

  setProductName(productName) {
    this.productName = productName;
  }

  setColorsByProduct(colorsByProduct) {
    this.colorsByProduct = colorsByProduct;
  }

  setAllColors(allColors) {
    this.allColors = allColors;
  }

  setFeatureProductsData(featureProductsData) {
    this.featureProductsData = featureProductsData;
  }

  setProductsData(productsData) {
    this.productsData = productsData;
  }

  setProductCategoryId(productCategoryId) {
    this.productCategoryId = productCategoryId;
  }

  setProductsCount(productsCount) {
    this.productsCount = productsCount;
  }

  setAllChecked(allchecked) {
    this.allchecked = allchecked;
  }

  setProductQuantity(productQuantity) {
    this.productQuantity = productQuantity;
  }

  setIsAddToCart(isAddToCart) {
    this.isAddToCart = isAddToCart;
  }

  setIsCartIcon(isCartIcon) {
    this.isCartIcon = isCartIcon;
  }

  setOpen(open) {
    this.open = open;
  }

  setIsLoader(isLoader) {
    this.isLoader = isLoader;
  }
  
  setBookings(bookings) {
    this.bookings = bookings;
  }
  setAllCart(allCart) {
    this.allCart = allCart;
  }

  setCartCount(cartCount) {
    this.cartCount = cartCount;
  }

  setProductSelectedSize(productSelectedSize) {
    this.productSelectedSize = productSelectedSize;
  }

  setProductSizeQuantity(sizeQuantity){
    this.productSizeQuantity=sizeQuantity;
  }

  setSeltIsQtySelectionInCart(isQtySelectionInCart) {
    this.isQtySelectionInCart = isQtySelectionInCart;
  }

  setMyCredits(myCredits) {
    this.myCredits = myCredits;
  }

  setDeliveryAddress(deliveryAddress) {
    this.deliveryAddress = deliveryAddress;
  }

  setLogout(logout) {
    this.logout = logout;
  }

  setMyOrders(myOrders) {
    this.myOrders = myOrders;
  }

  setMyProfile(myProfile) {
    this.myProfile = myProfile;
  }

  setMyWishlist(myWishlist) {
    this.myWishlist = myWishlist;
  }

  setReferFriend(referFriend) {
    this.referFriend = referFriend;
  }
  setIsWishlistByProductId(isWishlistByProductId) {
    this.isWishlistByProductId = isWishlistByProductId;
  }
  setWishlistData(wishlistData) {
    this.wishlistData = wishlistData;
  }
  setIsNewAddress(isNewAddress) {
    this.isNewAddress = isNewAddress;
  }
  setAddresses(addresses) {
    this.addresses = addresses;
  }
  setAddressId(addressId) {
    this.addressId = addressId;
  }
  setUpdateAddress(updateAddress) {
    this.updateAddress = updateAddress;
  }
  setIsUserLogin(isUserLogin) {
    this.isUserLogin = isUserLogin;
  }
  setCustomerLogin(customerLogin) {
    this.customerLogin = customerLogin;
  }
  setReferCode(referCode) {
    this.referCode = referCode;
  }
  setWallet(wallet) {
    this.wallet = wallet;
  }

  setProductSelectedImg(productSelectedImg) {
    this.productSelectedImg = productSelectedImg;
  }

  setTotalRefNoAndBalance(totalRefNoAndBalance) {
    this.totalRefNoAndBalance = totalRefNoAndBalance;
  }


  setIsCheckout(isCheckout) {
    this.isCheckout = isCheckout;
  }
  setIsAddressModalShow(isAddressModalShow) {
    this.isAddressModalShow = isAddressModalShow;
  }

  setAllCheckoutData(allCheckoutData) {
    this.allCheckoutData = allCheckoutData;
  }

  setBuyNowLoader(buyNowLoader) {
    this.buyNowLoader = buyNowLoader;
  }
  setCreateOrder(createOrder) {
    this.createOrder = createOrder;
  }

  setOrdersData(ordersData) {
    this.ordersData = ordersData;
  }
 
  setOrderDetailsData(orderDetailsData) {
    this.orderDetailsData = orderDetailsData;
  }

  setUpdateOrderStatus(message) {
    this.serviceControlData.UpdateOrderStatus = message;
  }


  /**
   * Reducers Functions
   */

  isProductAlreadyAddedInCart() {

    if (toJS(this.allCart?.productsModal?.length) > 0 && toJS(this.allCart?.productsModal)?.find((product) => product.id == toJS(dataStore.productId) && product.size == toJS(dataStore.productSelectedSize)) != undefined) return true;
    return false;
  }

  removeProductFromWishlist(item){
    this.wishlistData=this.wishlistData.filter((product)=>product.id!=toJS(item.id));
  }



}

const dataStore = new DataStore();
export default dataStore;
